module.exports = __webpack_public_path__ + "static/media/PM139.30994028.png";